import React from 'react';
import { Row, Col } from 'antd';
import { Player } from '@lottiefiles/react-lottie-player';
import { addApolloState, initializeApollo } from 'library/apolloClient';
import { checkLoggedIn } from 'library/auth';
import BasicLayout from 'layout/BasicLayout';
import { API_BASE_URL } from 'utils/config';
import { FcGoogle } from 'react-icons/fc';

function SignIn() {
  return (
    <BasicLayout>
      <div className="ss-layout" style={{ height: '100vh' }}>
        <main className="ss-wrapper">
          <div className="ss-bg-wrapper">
            <div className="d-none d-md-block ss-bg" />
          </div>
          <div className="ss-center-wrapper">
            <div className="container ss-container" style={{ padding: 0 }}>
              <Row>
                <Col xs={24} md={{ span: 10, offset: 2 }}>
                  <div className="title-section">
                    <h1 className="title text-center text-md-left mb-3">
                      Baby Shark World App Admin
                    </h1>
                    <div className="login-form text-center text-md-left">
                      <a
                        className="ant-btn ant-btn-lg ss-login ant-btn-block"
                        href={`${API_BASE_URL}/connect/google`}
                        style={{
                          display: 'inline-flex',
                          justifyContent: 'center',
                        }}
                      >
                        <span
                          role="img"
                          aria-label="google-sign-in"
                          className="anticon"
                          style={{ lineHeight: '43px' }}
                        >
                          <FcGoogle />
                        </span>{' '}
                        <span>Google 계정 로그인</span>
                      </a>
                    </div>
                    <p className="ie-warning text-center text-md-left">
                      Baby Shark World Admin은{' '}
                      <a
                        href="https://www.google.com/chrome/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Google Chrome 브라우저
                      </a>
                      에 최적화되어있습니다. <br />
                      (Internet Explorer에서는 사용할 수 없습니다.)
                    </p>
                  </div>
                </Col>
                <Col md={10} className="d-none d-md-block">
                  <div className="video-section">
                    <Player
                      autoplay
                      loop
                      controls={false}
                      src="https://assets10.lottiefiles.com/packages/lf20_6wcsn2aj.json"
                      style={{ width: '100%' }}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </main>
      </div>

      {/* language="CSS" */}
      <style jsx>{`
        .ss-layout {
          background-color: #f0f2f5;
        }

        .ss-container {
          margin: 0 auto;
        }

        .ss-login {
          max-width: 300px;
        }

        .login-form {
          width: 300px;
        }

        @media (max-width: 991px) {
          .login-form {
            margin: 0 auto;
          }

          .ss-bg-wrapper {
            min-height: 867px;
          }
        }

        .title-section {
          padding: 0 2rem;
          height: 100%;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          justify-content: center;
        }

        .video-section {
          height: 100%;
        }

        .title {
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 0.25rem;
          line-height: 68px;
        }

        .sub-title {
          font-size: 1.7rem;
          font-weight: 300;
        }

        .ie-warning {
          margin-top: 2em;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
        }

        .ss-bg-wrapper {
          width: 50%;
          height: 100%;
          min-height: initial;
          margin: 0 0 0 auto;
        }
      `}</style>
    </BasicLayout>
  );
}

export async function getServerSideProps(context) {
  const apolloClient = initializeApollo(null, context);
  const { loggedInUser } = await checkLoggedIn(apolloClient);
  if (loggedInUser.me)
    return {
      redirect: {
        destination: '/home',
        permanent: false,
      },
    };

  return addApolloState(apolloClient, {
    props: {},
  });
}

export default SignIn;
